import Vue from 'vue'
import Vuex from 'vuex'
import viewer from './modules/viewer'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    viewer
  }
})

export * from './modules/viewer'